__webpack_require__.p = "https://stdatavisualprod.blob.core.windows.net/$web/projects/24/12/politically-motivated-cases-in-kyrgyztan/";